import React from 'react';
import Client from 'shopify-buy';
import './App.css';
import ProductList from "./ProductList";
import ProductDetail from "./components/ProductDetailPage";
import Navbar from './components/Navbar';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import {ProductProvider} from "./components/products/productsContext"
import CartDetails from './components/CartDetails';

Client.buildClient({
  domain: 'conecuh-brands.myshopify.com',
  storefrontAccessToken: 'fd73aae121a8110089143a1d450c7b6e'
});

const App = () => { 
    return (
      <ProductProvider>
        <Router>
         <Navbar />
         <CartDetails />
         <Switch>
           <Route exact path="/merch" component={ProductList} />
           <Route path="/ProductDetail/:category" component={ProductDetail} />
         </Switch>
       </Router>
      </ProductProvider>    
    );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js